import React, { useState, useEffect } from 'react';
import EnhancedContractReview from './EnhancedContractReview';

const TestEnhancedReview: React.FC = () => {
  const [analysis] = useState<any | null>(null);
  const [loading] = useState(false);
  const [error] = useState<string | null>(null);

  useEffect(() => {
    // Disable auto-loading of any sample data in real mode
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 p-8">
        <div className="max-w-7xl mx-auto">
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
            <p className="mt-4 text-gray-600">Loading sample contract analysis...</p>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-gray-50 p-8">
        <div className="max-w-7xl mx-auto">
          <div className="bg-red-50 border border-red-200 rounded-lg p-6">
            <h3 className="text-lg font-semibold text-red-800 mb-2">Error</h3>
            <p className="text-red-600">{error}</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <div className="max-w-7xl mx-auto mb-8">
        <h1 className="text-3xl font-bold text-gray-800 mb-4">Enhanced Contract Review Demo</h1>
        <p className="text-gray-600">
          This demonstrates the new detailed contract analysis with JSON format. 
          The analysis includes detailed clause-by-clause breakdown with sub-clause issues, 
          risk assessments, negotiation recommendations, and more.
        </p>
      </div>
      
      <EnhancedContractReview
        contractId="12345"
        jsonAnalysis={analysis || undefined}
        onClauseUpdate={(clauseRef, updates) => {
          console.log('Clause update:', clauseRef, updates);
        }}
      />
    </div>
  );
};

export default TestEnhancedReview; 